/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineTaxDto
 */
export interface TravelineTaxDto {
    /**
     * Amount of tax or fee
     * @type {number}
     * @memberof TravelineTaxDto
     */
    amount: number;
    /**
     * Tax name
     * @type {string}
     * @memberof TravelineTaxDto
     */
    name: string;
    /**
     * Tax description
     * @type {string}
     * @memberof TravelineTaxDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the TravelineTaxDto interface.
 */
export function instanceOfTravelineTaxDto(value: object): value is TravelineTaxDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TravelineTaxDtoFromJSON(json: any): TravelineTaxDto {
    return TravelineTaxDtoFromJSONTyped(json, false);
}

export function TravelineTaxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineTaxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

  export function TravelineTaxDtoToJSON(json: any): TravelineTaxDto {
      return TravelineTaxDtoToJSONTyped(json, false);
  }

  export function TravelineTaxDtoToJSONTyped(value?: TravelineTaxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'name': value['name'],
        'description': value['description'],
    };
}

